// Card de menu con acciones: activar / archivar / asignar platos.
import type { MenuResponse } from '../../services/nutricionista'

interface MenuCardProps {
  menu: MenuResponse
  onAsignarPlatos: (m: MenuResponse) => void
  onVerCalendario: (m: MenuResponse) => void
  onActivar: (m: MenuResponse) => void
  onArchivar: (m: MenuResponse) => void
}

const ESTADO_COLOR: Record<string, string> = {
  borrador: 'bg-gray-200 text-gray-800',
  vigente: 'bg-green-200 text-green-900',
  archivado: 'bg-gray-300 text-gray-700',
}

export default function MenuCard({
  menu,
  onAsignarPlatos,
  onVerCalendario,
  onActivar,
  onArchivar,
}: MenuCardProps) {
  const archivado = menu.estado === 'archivado'
  const vigente = menu.estado === 'vigente'
  return (
    <article
      className="bg-white dark:bg-gray-800 rounded-lg shadow p-4 flex flex-col gap-2"
      aria-labelledby={`menu-${menu.id}-title`}
    >
      <header className="flex justify-between items-start">
        <div>
          <h3 id={`menu-${menu.id}-title`} className="font-bold text-base">
            {menu.codigo} — {menu.nombre}
          </h3>
          <p className="text-xs text-gray-500">
            Vigencia: {menu.fecha_vigencia_inicio}
            {menu.fecha_vigencia_fin ? ` → ${menu.fecha_vigencia_fin}` : ''}
          </p>
        </div>
        <span
          className={`text-xs px-2 py-0.5 rounded font-semibold uppercase ${
            ESTADO_COLOR[menu.estado] ?? 'bg-gray-200 text-gray-800'
          }`}
          aria-label={`Estado: ${menu.estado}`}
        >
          {menu.estado}
        </span>
      </header>

      {menu.notas && (
        <p className="text-sm text-gray-700 dark:text-gray-300 whitespace-pre-wrap">
          {menu.notas}
        </p>
      )}

      <footer className="flex gap-2 pt-2 border-t border-gray-100 dark:border-gray-700 flex-wrap">
        <button
          type="button"
          onClick={() => onVerCalendario(menu)}
          className="bg-avante-primary text-white px-3 py-1 rounded text-sm font-semibold"
        >
          Vista calendario
        </button>
        <button
          type="button"
          onClick={() => onAsignarPlatos(menu)}
          disabled={archivado}
          className="border border-avante-primary text-avante-primary px-3 py-1 rounded text-sm font-semibold disabled:opacity-50"
        >
          Asignar (batch)
        </button>
        {!vigente && !archivado && (
          <button
            type="button"
            onClick={() => onActivar(menu)}
            className="bg-avante-success text-white px-3 py-1 rounded text-sm font-semibold"
          >
            Activar
          </button>
        )}
        {!archivado && (
          <button
            type="button"
            onClick={() => onArchivar(menu)}
            className="border px-3 py-1 rounded text-sm"
          >
            Archivar
          </button>
        )}
      </footer>
    </article>
  )
}
